<div class="paypal-help-message">
    <div class="paypal-help-message-header">{{ siteCore.betslip.wallet.WalletHelpTitle }}</div>
    <div class="paypal-help-message-container" [innerHTML]="siteCore.betslip.wallet.WalletHelpSubTitle"></div>
    <a target="{{ nativeAppService.isNative ? '' : '_blank' }}" class="paypal-help-link" [href]="walletHelpUrl"
        >{{ appConfig.appName }}-{{ siteCore.betslip.wallet.WalletHelpLinkText }}</a
    >
    <div class="paypal-help-close-button" (click)="closeClick()">{{ siteCore.betslip.wallet.WalletHelpConfirm }}</div>
</div>
